import React from 'react';
// ANT

import Select from 'antd/lib/select';

const Option = Select.Option;

const ChoiceSelect = ({
  onChoiceChange, createInvoices, autoSend, onAutoSendChange,
}) => (
  <div style={{ padding: 25, paddingLeft: 0 }}>
    <div style={{ padding: 15 }}>
      <span style={{ fontSize: 16 }}>
        <Select
          size="large"
          onChange={val => onChoiceChange(val)}
          style={{
            fontSize: 16,
            width: 170,
            maxWidth: '100%',
            padding: 4,
          }}
          defaultValue={createInvoices}
        >
          <Option style={{ fontSize: 16 }} value="create">
            {' '}
            Create
          </Option>
          <Option style={{ fontSize: 16 }} value="dont-create">
            {' '}
            DO NOT Create
          </Option>
        </Select>
        and send these invoices automatically.
      </span>
    </div>
  </div>
);

ChoiceSelect.defaultProps = {
  onChoiceChange: () => {},
};

export default ChoiceSelect;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/InvoicesInfo/ChoiceSelect/index.js